import React from 'react';
import { FormControl, Select, MenuItem, FormHelperText } from '@mui/material';
import theme from 'theme/ThemeContext';

const CustomSelect = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  formWidth,
  placeholder,
  options = [],
  disabled = false,
  InputProps: inputProps = {},
  ...rest
}) => {
  return (
    <FormControl
      fullWidth
      size="small"
      error={Boolean(error)}
      disabled={disabled}
      sx={{width: formWidth ? formWidth : '100%'}}
    >
      <Select
        value={value}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        displayEmpty
        disabled={disabled}
        inputProps={{
          'aria-label': placeholder || 'select',
          ...inputProps,
        }}
        sx={{
          height: theme.formFileds.height,
          borderRadius: theme.formFileds.borderRadius,
          fontSize: '14px',
          // if no value selected, show placeholder in gray
          color: value ? 'inherit' : 'gray',
          ...(inputProps.sx || {}),
          ...(disabled && {
            '& .MuiSelect-icon': {
              display: 'none',
            },
          }),
        }}
        /* 
        // Optional alternative using renderValue:
        renderValue={(selected) =>
          selected
            ? options.find(o => o.value === selected)?.label
            : <span style={{ color: 'gray' }}>{placeholder}</span>
        }
        */
        {...rest}
      >
        {placeholder && (
          <MenuItem
            value=""
            disabled
            // ensure the dropdown placeholder item is gray
            sx={{ color: 'gray !important', fontSize: '14px' }}
          >
            {placeholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{ fontSize: '14px' }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomSelect;
